import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Toggle menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    const hamburgerBtn = document.querySelector(".hamburger-btn");
    if (hamburgerBtn) {
      hamburgerBtn.classList.toggle("active");
    }
    // Prevent scrolling when menu is open
    if (!menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  };

  const handleWaitingQClick = (e) => {
    e.preventDefault();
    window.open("https://waitingq.au/", "_blank");
    setMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" onClick={closeMenu}>
          <img
            src={process.env.PUBLIC_URL + "/images/picktechlogo.png"}
            alt="PICKTECH Logo"
            className="navbar-logo"
          />
          <span className="brand-text">PICKTECH</span>
        </Link>
      </div>

      <button
        className={`hamburger-btn ${menuOpen ? "active" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle Menu"
        aria-expanded={menuOpen}
      >
        <span className="hamburger-box">
          <span className="hamburger-inner"></span>
        </span>
      </button>

      <div className={`navbar-menu ${menuOpen ? "open" : ""}`}>
        <div className="nav-items-container">
          <Link to="/" className="nav-item" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/about" className="nav-item" onClick={closeMenu}>
            About
          </Link>
          <Link to="/webcraft" className="nav-item" onClick={closeMenu}>
            WebCraft Pro
          </Link>
          <a href="#" onClick={handleWaitingQClick} className="nav-item">
            WaitingQ
          </a>
          <span className="nav-item disabled">StampGo</span>
          <Link to="/contact" className="nav-item" onClick={closeMenu}>
            Contact
          </Link>
        </div>

        {isMobile && menuOpen && (
          <button
            className="menu-close-btn"
            onClick={closeMenu}
            aria-label="Close Menu"
          >
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
